import Rails from '@rails/ujs'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import dayjs from 'dayjs'
import VueCanCanCan from '@commons/plugins/can'
import { clipboard } from '@commons/directives/clipboard'
import { tooltip } from '@commons/directives/tooltip'
import { setCSRFToken, checkResponseStatus } from '@commons/interceptors'
import { headerMenu } from '@commons/helpers/headerMenu'
import globalHelpers from '@commons/helpers/global'

Vue.prototype.$env = process.env.NODE_ENV
Vue.prototype.$dayjs = dayjs
Vue.prototype.$gon = gon
Vue.prototype.$helpers = globalHelpers

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(VueCanCanCan, gon.abilities)

Vue.directive('clipboard', clipboard)
Vue.directive('tooltip', tooltip)

setCSRFToken()
checkResponseStatus()
Rails.start()

const DESKTOP_BREAKPOINT = 1200
const TABLET_BREAKPOINT = 768
const MOBILE_BREAKPOINT = 320

function initVueConfig(routes, baseStore, components, directives, plugins) {
  const store = new Vuex.Store(baseStore)
  const router = new VueRouter({
    routes: routes
  })

  // TODO: поменять " на ' везде
  router.beforeEach((to, from, next) => {
    document.title = to.meta.title || "Заголовок по умолчанию"
    next()
  })

  // router.beforeEach(VueCanCanCan.navigationGuard('/'))

  // router.beforeEach((to, from, next) => {
    // if (to.meta.abilityPath) {
      // const abilities = store.state.config.abilities
      // const permission = to.meta.abilityPath?.reduce((acc, path) => {
        // return acc[path]
      // }, abilities)
      // if (permission) next()
    // } else {
      // next()
    // }
  // })

  components?.forEach((component) => {
    Vue.component(component.name, component.component)
  })

  directives?.forEach((directive) => {
    Vue.directive(directive.name, directive.component)
  })

  plugins?.forEach((plugin) => {
    Vue.use(plugin.name, plugin.component)
  })

  // HEADER SCRIPTS
  headerMenu.initHeaderMenu()
  window.addEventListener('resize', function(event) {
    if (window.innerWidth >= TABLET_BREAKPOINT) {
      headerMenu.removeJsClassesFromHeaderMenu()
    }
  })
  // HEADER SCRIPITS END

  return new Vue({
    store,
    router,
    mounted() {
      this.$store.commit('config/SET_USER', gon.user)
      this.$store.commit('config/SET_AUTHENTICITY_TOKEN')
    }
  })
}

export { initVueConfig }